export default {
  report_id_label: "Berichts-ID",
  report_id_placeholder: "Berichts-ID zur Suche eingeben",
  type_label: "Typ",
  type_placeholder: "Typ auswählen",
  shared_label: "Geteilt",
  shared_placeholder: "Freigabestatus auswählen",
  report_id: "Berichts-ID",
  date: "Datum",
  report_type: "Berichtstyp",
  created_at: "Erstellt am",
  shared: "Geteilt",
  actions: "Aktionen",
  view_count: "Ansichten",
  regenerate: "Neu generieren",
  delete_confirm: "Sind Sie sicher, dass Sie diesen Bericht löschen möchten?",
  copied: "Link in die Zwischenablage kopiert",
  copied_with_expire: "Link in die Zwischenablage kopiert, läuft am {date} ab",
  copy_failed: "Link konnte nicht kopiert werden",
  share_failed: "Freigabe fehlgeschlagen",
  report_detail: "Berichtsdetail",
  preview_title: "Berichtsvorschau",
  data_format_error: "Datenformatfehler",
  plan_changed_notice:
    "Ihr Plan wurde geändert und verwendet nun den neuesten Plan ({planType}), um diesen Bericht anzuzeigen.",
  config_changed_notice:
    "Ihre Konfiguration wurde geändert und verwendet nun die neueste Konfiguration, um diesen Bericht anzuzeigen.",
  calculation_deleted_notice: "Einige Berechnungen wurden gelöscht.",
  delete_success: "Erfolgreich gelöscht",
  not_found_title: "Bericht nicht gefunden",
  not_found_desc: "Der gesuchte Bericht existiert nicht",
  share: "Teilen",
  copy_link: "Link kopieren",
  share_to_x: "Auf X teilen",
  share_to_linkedin: "Auf LinkedIn teilen",
  unshare: "Freigabe aufheben",
  unshare_success: "Berichtsfreigabe erfolgreich aufgehoben",
  unshare_failed: "Aufhebung der Berichtsfreigabe fehlgeschlagen",
  shared_expires_at: "Freigabe läuft ab am",
  privacy_fields_hidden:
    "Datenschutzfelder sind standardmäßig ausgeblendet, können in Einstellungen - Berichtskonfiguration geändert werden, Änderungen treten sofort in Kraft",
  want_to_calculate:
    "Möchten Sie Ihren eigenen CBAM-Kohlenstoffsteuerbericht berechnen? Erhalten Sie 50 Berechnungen nach der ersten Berechnung",
  register_free: "Kostenlos registrieren",
  use_invitation_code: "Einladungscode verwenden",
  failed_to_load_shared_report: "Geteilter Bericht konnte nicht geladen werden",
  report_data_missing: "Berichtsdaten fehlen",
  unable_to_get_shared_report: "Geteilte Berichtsdaten konnten nicht abgerufen werden",
  carbon_emission_report: "Kohlenstoffemissionsbericht",
  check_out_carbon_emission: "Schauen Sie sich diesen Kohlenstoffemissionsbericht an",
};
